import React from 'react';
import { Star } from 'lucide-react';

const bullets = {
  en: [
    'Holistic training for body and mind',
    'Science-backed nutrition recommendations',
    'Sustainable results without the yo-yo effect',
    'Swiss quality for your everyday life',
  ],
  de: [
    'Ganzheitliches Training für Körper und Geist',
    'Wissenschaftlich fundierte Ernährungsempfehlungen',
    'Nachhaltige Ergebnisse ohne Jojo-Effekt',
    'Swiss-Qualität für deinen Alltag',
  ],
};

export default function FinalCTA({ lang }) {
  const t = {
    supra: lang === 'de' ? 'Bereit?' : 'Ready?',
    headline: lang === 'de' ? 'DEIN WEG ZU ECHTEM WOHLBEFINDEN BEGINNT HEUTE' : 'YOUR PATH TO REAL WELLBEING STARTS TODAY',
    sub:
      lang === 'de'
        ? 'Starte noch heute und verändere deinen Körper nachhaltig. Schweizer Qualität trifft auf modernste Fitness-Technologie.'
        : 'Start today and transform your body for the long term. Swiss quality meets state-of-the-art fitness technology.',
    cta: lang === 'de' ? 'WOHLBEFINDEN STARTEN' : 'START YOUR WELLNESS',
  };

  return (
    <section className="bg-gradient-to-br from-emerald-700 via-emerald-600 to-teal-700 py-24 lg:py-32 relative overflow-hidden">
      {/* Decorative background shapes */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-lime-300/10 rounded-full translate-x-1/3 translate-y-1/3 blur-3xl" />

      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Supra label */}
        <span className="inline-flex items-center gap-1.5 px-4 py-1.5 bg-white/15 text-white/90 text-xs font-bold uppercase tracking-widest rounded-full mb-6">
          <Star size={11} fill="currentColor" />
          {t.supra}
        </span>

        {/* Headline */}
        <h2 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-black text-white tracking-tight mb-6">
          {t.headline}
        </h2>

        <p className="text-white/75 text-lg max-w-xl mx-auto leading-relaxed mb-10">{t.sub}</p>

        {/* Bullet pills */}
        <div className="flex flex-wrap justify-center gap-3 mb-12">
          {bullets[lang].map((b, i) => (
            <span
              key={i}
              className="px-4 py-2 bg-white/10 text-white text-sm font-semibold rounded-full border border-white/20 backdrop-blur-sm"
            >
              ✓ {b}
            </span>
          ))}
        </div>

        {/* CTA Button */}
        <a
          href="/s"
          className="inline-flex items-center gap-3 px-10 py-5 bg-white text-emerald-700 font-black text-xl rounded-2xl shadow-2xl hover:shadow-white/20 hover:bg-slate-50 hover:scale-105 transition-all duration-300"
        >
          {t.cta}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="w-6 h-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2.5}
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
          </svg>
        </a>

        {/* Trust line */}
        <p className="mt-8 text-white/50 text-sm">
          {lang === 'de'
            ? 'Keine Kreditkarte erforderlich · Jederzeit kündbar · 🇨🇭 Made in Switzerland'
            : 'No credit card required · Cancel anytime · 🇨🇭 Made in Switzerland'}
        </p>
      </div>
    </section>
  );
}
